"use strict";
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (
          !desc ||
          ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)
        ) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            },
          };
        }
        Object.defineProperty(o, k2, desc);
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
      }
    : function (o, v) {
        o["default"] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.OUT_SCENE_EFFECT =
  exports.IN_SCENE_EFFECT =
  exports.CONTENT_POSITION =
  exports.OPACITY_LAYOUT_COLORS =
    void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const prop_types_1 = __importDefault(require("prop-types"));
const utils_metrics_send_ga_event_1 = __importDefault(
  require("@gcloud-npm/utils.metrics.send-ga-event")
);
const utils_common_get_device_kind_depends_on_viewport_1 = __importDefault(
  require("@gcloud-npm/utils.common.get-device-kind-depends-on-viewport")
);
const react_redux_1 = require("react-redux");
const reducers_modals_reducer_1 = require("@/bit/reducers/reducers.modals-reducer");
const enums_1 = require("./enums");
Object.defineProperty(exports, "CONTENT_POSITION", {
  enumerable: true,
  get: function () {
    return enums_1.CONTENT_POSITION;
  },
});
Object.defineProperty(exports, "IN_SCENE_EFFECT", {
  enumerable: true,
  get: function () {
    return enums_1.IN_SCENE_EFFECT;
  },
});
Object.defineProperty(exports, "OPACITY_LAYOUT_COLORS", {
  enumerable: true,
  get: function () {
    return enums_1.OPACITY_LAYOUT_COLORS;
  },
});
Object.defineProperty(exports, "OUT_SCENE_EFFECT", {
  enumerable: true,
  get: function () {
    return enums_1.OUT_SCENE_EFFECT;
  },
});
const utils_1 = require("./utils");
let modalRoot = null;
/**
 * Ventana emergente que muestra contenido adicional o interactivo, bloqueando la interacción con el resto de la aplicación hasta que se cierre.
 */
class Modal extends react_1.Component {
  constructor(props) {
    super(props);
    this.blur = (e) => {
      if (e.key === "Tab" && e.shiftKey) {
        this.__hide();
      }
    };
    this.createContentCss = (
      contentPosition,
      inSceneEffect,
      outSceneEffect,
      show,
      className
    ) => {
      const arrayContentPosition =
        contentPosition && contentPosition.split("--");
      const isCustom =
        Array.isArray(arrayContentPosition) &&
        arrayContentPosition.length > 0 &&
        arrayContentPosition[0] === enums_1.CONTENT_POSITION.CUSTOM;
      let cssContentPosition = "";
      let customPosition = {};
      let currentContentPosition = contentPosition;
      if (isCustom) {
        cssContentPosition = "Modal_content Modal_content--custom";
        currentContentPosition = "custom";
        if (arrayContentPosition.length > 3) {
          const positionX = arrayContentPosition[1];
          const positionY = arrayContentPosition[2];
          const currentTransform = arrayContentPosition[3];
          customPosition = {
            top: `${positionY}`,
            left: `${positionX}`,
            transform: currentTransform,
          };
        }
      } else {
        cssContentPosition = contentPosition
          ? `Modal_content Modal_content--${contentPosition}`
          : "";
      }
      let sceneCss = inSceneEffect
        ? ` Modal_content--${currentContentPosition}--${inSceneEffect}`
        : "";
      if (!show) {
        sceneCss = outSceneEffect
          ? ` Modal_content--${currentContentPosition}--${outSceneEffect}`
          : "";
      }
      const cssOwnClassName = className ? ` ${className}` : "";
      return {
        contentCss: `${cssContentPosition}${sceneCss}${cssOwnClassName}`,
        customPosition,
      };
    };
    this.createOpacityLayoutCss = (opacityLayoutColor, show) => {
      if (opacityLayoutColor === "blur") {
        return (
          (show && `Single_Modal blur_layout Single_Modal--fadeIn`) ||
          `Single_Modal blur_layout Single_Modal--fadeOut`
        );
      }
      return (
        (show &&
          `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeIn`) ||
        `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeOut`
      );
    };
    this.handleCloseOnLayout = () => {
      const {
        onCloseHandler,
        taggingInfoWhenClickingOutside,
        closeByClickingOutside,
      } = this.state;
      if (closeByClickingOutside) {
        const taggingInfo = taggingInfoWhenClickingOutside
          ? Object.assign(Object.assign({}, taggingInfoWhenClickingOutside), {
              event_type: "click",
            })
          : {
              componentName: "Modal",
              componentVariation: "none",
              componentContent: "cerrar-modal-click-fuera",
              componentPerso: "",
              componentProduct: "",
              event_type: "click",
            };
        (0, utils_metrics_send_ga_event_1.default)(taggingInfo);
        if (onCloseHandler) {
          onCloseHandler();
        }
      }
    };
    this.setModalRoot = () => {
      modalRoot = document.getElementsByClassName("modal-root")[0];
    };
    this.setScrollOnElements = (scrollValue) => {
      const body = document.getElementsByTagName("body")[0];
      const html = document.getElementsByTagName("html")[0];
      body.style.overflowY = scrollValue;
      html.style.overflowY = scrollValue;
    };
    this.__show = () => {
      const { scrollAllowed } = this.state;
      // show modal-root
      modalRoot.classList.add("visible");
      // disallow scroll on html,body
      if (!scrollAllowed) {
        this.setScrollOnElements("hidden");
      } else {
        this.setScrollOnElements("auto");
      }
      // set properties
      this.setState({
        show: true,
        unMounted: false,
      });
      if (document) {
        this.prevFocusElementRef.current = document.activeElement;
      }
    };
    this.__hide = () => {
      this.handleCloseOnLayout();
      this.setScrollOnElements("auto");
      this.setState({ show: false, disableModalAutofocus: false });
    };
    this.keyDownHandler = (e) => {
      if (e.key === "Tab" && e.shiftKey) {
        cojsole.log(e.target);
      }
    };
    this.renderModalContent = (
      contentInsideContainer,
      content,
      contentCss,
      customPosition
    ) => {
      const device = (0,
      utils_common_get_device_kind_depends_on_viewport_1.default)();
      if (contentInsideContainer && device !== "MOBILE") {
        return react_1.default.createElement(
          "div",
          { className: "xux" },
          react_1.default.createElement(
            "div",
            { className: "container" },
            react_1.default.createElement(
              "div",
              { className: `${contentCss}`, style: customPosition },
              content
            )
          )
        );
      }
      return react_1.default.createElement(
        "div",
        { className: `${contentCss}`, style: customPosition },
        content
      );
    };
    this.setModalRootNull = () => {
      modalRoot = null;
    };
    const { projectId } = props;
    this.isClosing = false;
    if (typeof window !== "undefined" && !modalRoot) {
      this.setModalRoot(projectId);
      Modal.__singletonRef = this;
    }
    this.prevFocusElementRef = react_1.default.createRef();
    const {
      opacityLayoutColor,
      contentPosition,
      className,
      inSceneEffect,
      outSceneEffect,
      closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      contentInsideContainer,
      scrollAllowed,
      onCloseHandler,
      closeIdByClickingOutside,
      historyBackOnClose,
    } = props;
    this.state = {
      unMounted: true,
      show: false,
      className,
      inSceneEffect,
      outSceneEffect,
      contentPosition,
      opacityLayoutColor,
      closeIdByClickingOutside,
      closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      contentInsideContainer,
      scrollAllowed,
      onCloseHandler,
      historyBackOnClose,
    };
  }
  static show() {
    Modal.__singletonRef.__show();
  }
  static hide() {
    Modal.__singletonRef.__hide();
  }
  static setContent(component) {
    Modal.__singletonRef.__setContent(component);
  }
  static setModalProps(props) {
    Modal.__singletonRef.__setModalProps(props);
  }
  focusOnModalContent() {
    const { disableModalAutofocus } = this.state;
    if (!disableModalAutofocus) {
      if (modalRoot) {
        modalRoot.setAttribute("tabindex", "0");
        modalRoot.focus();
      }
    }
  }
  focusOnPrevContent() {
    const { disableModalAutofocus } = this.state;
    if (!disableModalAutofocus) {
      if (modalRoot) {
        modalRoot.setAttribute("tabindex", "-1");
      }
      if (this.prevFocusElementRef.current) {
        this.prevFocusElementRef.current.focus();
      }
    }
  }
  firstFocusableElement() {
    const container = document.querySelector(".Modal_content");
    if (!container) return null;

    const all = container.querySelectorAll(
      "input, select, textarea, button, object, a[href], area[href], [tabindex]"
    );

    // Convertimos NodeList a Array y filtramos tabIndex != -1
    const focusables = Array.from(all).filter((el) => el.tabIndex !== -1);

    return focusables.length > 0 ? focusables[0] : null;
  }
  /* this handle transition and unmounted event */
  componentDidUpdate() {
    const { show, unMounted, disableModalAutofocus } = this.state;
    if (show) {
      if (!unMounted) {
        const transitionEvent = (0, utils_1.whichAnimationEvent)();
        const element = document.getElementById("animationReference");
        element.addEventListener(transitionEvent, () => {
          this.focusOnModalContent();
          if (!disableModalAutofocus) {
            let retries = 8;
            let interval = setInterval(() => {
              var elementF = this.firstFocusableElement();
              if (elementF) {
                elementF.removeEventListener("keydown", this.blur);
                elementF.addEventListener("keydown", this.blur);
              }
              if (retries <= 0) {
                clearInterval(interval);
              }
              retries--;
            }, 200);
          }
        });
      } else {
        this.focusOnModalContent();
      }
    } else {
      if (!unMounted) {
        const transitionEvent = (0, utils_1.whichAnimationEvent)();
        const element = document.getElementById("animationReference");
        if (transitionEvent) {
          element.addEventListener(transitionEvent, () => {
            // hide modal root
            modalRoot.classList.remove("visible");
            this.setState({ unMounted: true }, () => {
              this.isClosing = false;
            });
            this.focusOnPrevContent();
          });
        }
      } else {
        this.focusOnPrevContent();
      }
    }
  }
  __setContent(content) {
    this.setState({ content });
  }
  __setModalProps(props) {
    const propsCopy = Object.assign({}, props);
    if (propsCopy.show) {
      delete propsCopy.show;
    }
    const { scrollAllowed } = props;
    if (scrollAllowed) {
      this.setScrollOnElements("auto");
    }
    this.setState(Object.assign({}, propsCopy));
  }
  componentWillUnmount() {
    this.setScrollOnElements("auto");
    this.setState({ show: false });
    this.setModalRootNull();
  }
  render() {
    const { addModal } = this.props;
    const {
      opacityLayoutColor,
      contentPosition,
      className,
      inSceneEffect,
      outSceneEffect,
      unMounted,
      contentInsideContainer,
      closeIdByClickingOutside,
      closeByClickingOutside,
    } = this.state;
    const { show, content } = this.state;
    const cssOpaticyLayout = this.createOpacityLayoutCss(
      opacityLayoutColor,
      show
    );
    const { contentCss, customPosition } = this.createContentCss(
      contentPosition,
      inSceneEffect,
      outSceneEffect,
      show,
      className
    );
    if ((!show && unMounted) || !content) {
      return null;
    }
    return (0, react_dom_1.createPortal)(
      react_1.default.createElement(
        react_1.default.Fragment,
        null,
        this.renderModalContent(
          contentInsideContainer,
          content,
          contentCss,
          customPosition
        ),
        react_1.default.createElement("div", {
          id: "animationReference",
          className: `${cssOpaticyLayout} closeByClickingOutside--${closeByClickingOutside}`,
          tabIndex: 0,
          style: {
            cursor: !closeByClickingOutside ? "auto" : "pointer",
          },
          onFocus:
            closeByClickingOutside && !this.isClosing
              ? (e) => {
                  this.isClosing = true;
                  addModal({
                    id: closeIdByClickingOutside,
                    omitAnchorListener: true,
                  });
                }
              : null,
        })
      ),
      modalRoot
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  addModal: (data) =>
    dispatch(reducers_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(Modal);
Modal.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "ClassName"
   * }
   */
  className: prop_types_1.default.string,
  /**
   * {
   *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
   *  "kind": "both",
   *  "beautifulName": "CloseByClickingOutside"
   * }
   */
  closeByClickingOutside: prop_types_1.default.bool,
  /**
   * {
   *  "info": "Objeto para la customización cuando se hace click fuera de la modal",
   *  "kind": "both",
   *  "beautifulName": "TaggingInfoWhenClickingOutside"
   * }
   */
  taggingInfoWhenClickingOutside: prop_types_1.default.object,
  /**
   * {
   *  "info": "Define la posición que ocupará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "ContentPosition"
   * }
   */
  contentPosition: prop_types_1.default.oneOf([
    enums_1.CONTENT_POSITION.CENTER_CENTER,
    enums_1.CONTENT_POSITION.CENTER_TOP,
    enums_1.CONTENT_POSITION.RIGHT_TOP,
    enums_1.CONTENT_POSITION.LEFT_TOP,
    enums_1.CONTENT_POSITION.CENTER_BOTTOM,
  ]),
  /**
   * {
   *  "info": "Define el color de background de la capa layout que cubre la pantalla bajo la modal",
   *  "kind": "both",
   *  "beautifulName": "OpacityLayoutColor"
   * }
   */
  opacityLayoutColor: prop_types_1.default.oneOf([
    enums_1.OPACITY_LAYOUT_COLORS.BLACK,
    enums_1.OPACITY_LAYOUT_COLORS.WHITE,
    enums_1.OPACITY_LAYOUT_COLORS.DARKBLUE,
    enums_1.OPACITY_LAYOUT_COLORS.BLACK05,
    enums_1.OPACITY_LAYOUT_COLORS.TRANSPARENT,
  ]),
  /**
   * {
   *  "info": "Define el efecto con el que se mostrará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "InSceneEffect"
   * }
   */
  inSceneEffect: prop_types_1.default.oneOf([
    enums_1.IN_SCENE_EFFECT.FADE_IN,
    enums_1.IN_SCENE_EFFECT.FADE_IN_LEFT,
    enums_1.IN_SCENE_EFFECT.FADE_IN_RIGHT,
    enums_1.IN_SCENE_EFFECT.FADE_IN_TOP,
    enums_1.IN_SCENE_EFFECT.FADE_IN_BOTTOM,
  ]),
  /**
   * {
   *  "info": "Define el efecto con el que se ocultará la modal al ser cerrada",
   *  "kind": "both",
   *  "beautifulName": "OutSceneEffect"
   * }
   */
  outSceneEffect: prop_types_1.default.oneOf([
    enums_1.OUT_SCENE_EFFECT.FADE_OUT,
    enums_1.OUT_SCENE_EFFECT.FADE_OUT_LEFT,
    enums_1.OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    enums_1.OUT_SCENE_EFFECT.FADE_OUT_BOTTOM,
    enums_1.OUT_SCENE_EFFECT.FADE_OUT_TOP,
  ]),
  /**
   * {
   *  "info": "Define si la modal se tiene que mostrar dentro del elemento container de la página o fuera de él",
   *  "kind": "both",
   *  "beautifulName": "ContentInsideContainer"
   * }
   */
  contentInsideContainer: prop_types_1.default.bool,
  /**
   * {
   *  "info": "Define si la modal permite scroll",
   *  "kind": "both",
   *  "beautifulName": "ScrollAllowed"
   * }
   */
  scrollAllowed: prop_types_1.default.bool,
  /**
   * {
   *  "info": "Método que se ejecuta al hacer click fuera del modal",
   *  "kind": "both",
   *  "beautifulName": "OnCloseHandler"
   * }
   */
  onCloseHandler: prop_types_1.default.func,
  /**
   * {
   *  "info": "Define si hace historyBack al cerrar la modal",
   *  "kind": "both",
   *  "beautifulName": "HistoryBackOnClose"
   * }
   */
  historyBackOnClose: prop_types_1.default.bool,
};
Modal.defaultProps = {
  className: "",
  closeIdByClickingOutside: "",
  closeByClickingOutside: true,
  taggingInfoWhenClickingOutside: null,
  contentPosition: enums_1.CONTENT_POSITION.CENTER_BOTTOM,
  opacityLayoutColor: enums_1.OPACITY_LAYOUT_COLORS.BLACK,
  inSceneEffect: enums_1.IN_SCENE_EFFECT.FADE_IN,
  outSceneEffect: enums_1.OUT_SCENE_EFFECT.FADE_OUT,
  contentInsideContainer: false,
  scrollAllowed: false,
  onCloseHandler: null,
  historyBackOnClose: true,
};
//# sourceMappingURL=index.js.map
